import React, { useState } from "react";
import Announcement from "../components/Announcement/Announcement";
import Aside from "../modules/SideNav/Aside";

function AnnouncementSidenavLayout() {
  const rtl = false;

  const [toggled, setToggled] = useState(false);

  const handleToggleSidebar = (value) => {
    setToggled(value);
  };
  return (
    <div className={`app ${rtl ? "rtl" : ""} ${toggled ? "toggled" : ""}`}>
      <Aside
        rtl={rtl}
        toggled={toggled}
        handleToggleSidebar={handleToggleSidebar}
      />
      <Announcement handleToggleSidebar={handleToggleSidebar} />
    </div>
  );
}

export default AnnouncementSidenavLayout;
